export default __webpack_public_path__ + "static/media/teamo.b06f096b.png";